/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Operatinghoursp12Inputs */



/**
* | output |
* | --- |
* | "Left/top pump operating hours" |
*
* @param {Ahu_History_Key_Operatinghoursp12Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_operatinghoursp12 = /** @type {((inputs?: Ahu_History_Key_Operatinghoursp12Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Operatinghoursp12Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Left/top pump operating hours")
	return /** @type {LocalizedString} */ ("Temps de fonctionnement pompe gauche/haute")
});
export { ahu_history_key_operatinghoursp12 as "ahu_history_key_operatingHoursP1" }